import { DataProvider } from '@components/abb-table/data-source';
import { Observable, filter, map } from 'rxjs';

export function dataProviderFromObservable<T, TFilters>(
  obs$: Observable<T[] | null>,
  filterFn: (el: T, filters: TFilters) => boolean,
  sortFn?: (
    a: T,
    b: T,
    cols: { column: keyof T; order: 'asc' | 'desc' }[]
  ) => number
): DataProvider<T, TFilters> {
  const provider: DataProvider<T, TFilters> = ({
    filters,
    range,
    sortParams,
  }) => {
    return obs$.pipe(
      filter((v) => v !== null),
      map((el) => {
        const filtered = el?.filter((v) => filterFn(v, filters)) ?? [];
        if (sortFn) {
          filtered.sort((a, b) => sortFn(a, b, sortParams));
        }
        const sliced = filtered.slice(range.start, range.end);
        return { items: sliced, total: filtered.length };
      })
    );
  };
  return provider;
}
